export default {
  fromServer: data => ({
    uid: data.uid,
    email: data.email,
    firstName: data.first_name,
    lastName: data.last_name,
    company: data.company,
    title: data.title,
    language: data.language,
    removed: data.removed,
    photoUrl: data.photo_url,
    photoThumbnailUrl: data.photo_thumbnail_url,
  }),
};
